import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
import Request from '../Request';
export default (function (organisationId, assetId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_DELETE_REMARK, {
        organisationId: organisationId,
        assetId: assetId
    });
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
